export default {
  id: 157,
  title: 'Target #157 - Monopoly',
  url: 'https://cssbattle.dev/play/157',
  colors: ['#E38F66', '#FFFBDA'],
  solution:
    '<a a><a b><a c><a d><a e><style>[b],[c]{height:20;border-radius:9in}[d],[e]{top:220;width:40;height:40;background:#fffbda;transform:rotate(45deg)}body{background:#e38f66}a{position:fixed}[a]{top:40;left:140;width:120;height:100;background:#fffbda;border-radius:9in 9in 0 0}[b]{top:130;left:110;width:180;background:#fffbda}[c]{top:172;left:160;width:20;background:#fffbda;box-shadow:60px 0 #e38f66,60px 0 0 10px #fffbda}[d]{left:155;border-radius:9in 9in 9in 0}[e]{right:155;border-radius:9in 0 9in 9in}</style>',
}
